import { TeachingBlockVersionTeachersTable } from '../../../../../../components/TeachingBlockVersion/TeachingBlockVersionDataTables/TeachingBlockVersionTeachersTable';
import { hexToColorOption } from '../../../../../../utils/colorUtils';
import { TeachingBlockResourceConfig, TeachingBlockResourceDataPage } from '../TeachingBlockResourceDataPage';

const teacherConfig: TeachingBlockResourceConfig = {
  entityType: 'teacher',
  exclusionHolderType: 'Person',
  relationKey: 'teachers',
  lessonFilterColumn: 'teachers',
  searchName: 'teacher-search',
  importDisabled: (store, basicData) => {
    const missingTeachers = basicData.teacherData.people.filter((t) => {
      return !store.teachers.has(t.uuid);
    });
    return store.readonly || missingTeachers.length === 0;
  },
  importLabelKey: 'persons.title',
  getVersionUuids: (store) => Array.from(store.teachers.keys()),
  getRows: (basicData, versionUuids) =>
    basicData.teacherData?.people
      .filter((t) => versionUuids.includes(t.uuid))
      .map((t) => {
        const { html, label } = hexToColorOption(t.timetableConfig?.color ?? '');
        return {
          color: { color: html, label },
          count: 0,
          name: t.displayNameShort ?? t.fullName,
          shortName: t.shortName,
          uuid: t.uuid,
        };
      }) ?? [],
  removeEntities: (store, uuids) => store.removeTeachers(uuids),
  renderTable: ({ versionUuid, search, versionUuids, onRowSelection, onShowLessonClick, onRemove }) => (
    <TeachingBlockVersionTeachersTable
      versionUuid={versionUuid}
      search={search}
      versionTeacherUuids={versionUuids}
      onRowSelection={onRowSelection}
      onShowLessonClick={onShowLessonClick}
      onRemove={onRemove}
    />
  ),
};

export const PlanTeachingBlockTeachers = () => <TeachingBlockResourceDataPage config={teacherConfig} />;
